export default __webpack_public_path__ + "static/media/ic_svc_muse.6bab69dc.png";